module.exports = __webpack_public_path__ + "img/filters-arrow-icon-up.f949b4c4.svg";